"use strict";
/*!
 *
 *  tab.js
 *
 */
var tabContents = /** @class */ (function () {
    function tabContents(elem, opt) {
        var _this = this;
        this.setting = {
            baseClass: 'common_tab',
            cntClass: '-current'
        };
        this.$tab = $(elem);
        this.setting = $.extend({}, this.setting, opt);
        var $nav = this.$tab.find('.' + this.setting.baseClass + '_nav');
        this.$item = $nav.find('.' + this.setting.baseClass + '_nav_item');
        this.$a = this.$item.find('a');
        this.$inner = this.$tab.find('.' + this.setting.baseClass + '_inner');
        this.$a.on('click', function (e) {
            e.preventDefault();
            if (!$(e.currentTarget).closest('.' + _this.setting.baseClass + '_nav_item').is('.-current')) {
                var target = $(e.currentTarget).attr('href');
                _this.$item.removeClass('-current');
                _this.$inner.removeClass('-current');
                $(e.currentTarget).closest('.' + _this.setting.baseClass + '_nav_item').addClass('-current');
                $(target).addClass('-current');
            }
            ;
        });
    }
    return tabContents;
}());
;
$.fn.tab = function (options) {
    var opt = options ? options : {};
    if (this.length > 0) {
        return this.each(function () {
            new tabContents(this, opt);
        });
    }
    ;
};
